import React from 'react';
import { useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { Flex } from '@chakra-ui/react';

import RequirementTemplateBlueprintType from '../../../../../../types/RequirementTemplateBlueprintType';
import BackButton from '../../../../../BackButton';

function RequirementTemplateBuilderHeaderLeft({ blueprint }) {
  const dispatch = useDispatch();
  const { url } = useRouteMatch();
  const templateUrl = url.replace(/create-templates.*/, 'templates/requirement-templates');

  return (
    <Flex justifyContent="space-evenly">
      <BackButton
        executable={() => {
          dispatch(blueprint.resetSelectedTemplate());
          dispatch(blueprint.resetCurrentFolder());
        }}
        text="Templates"
        url={templateUrl}
      />
    </Flex>
  );
}

RequirementTemplateBuilderHeaderLeft.propTypes = { blueprint: RequirementTemplateBlueprintType };

export default RequirementTemplateBuilderHeaderLeft;
